import React from 'react';
import '../../../styles/components/skeleton-loader.css';

interface SkeletonProps {
  width?: string;
  height?: string;
  variant?: 'text' | 'circle' | 'rectangle' | 'tag' | 'button' | 'icon' | 'image' | 'title' | 'subtitle';
  className?: string;
}

export const Skeleton: React.FC<SkeletonProps> = ({
  width,
  height,
  variant = 'text',
  className = ''
}) => {
  const classes = [
    'skeleton',
    `skeleton--${variant}`,
    className
  ].filter(Boolean).join(' ');

  const style = {
    ...(width && { width }),
    ...(height && { height })
  };

  return <div className={classes} style={style} />;
};

// Templates prédéfinis pour les cartes d'événements
interface EventCardSkeletonProps {
  variant?: 'simple' | 'recurring';
  className?: string;
}

// Template pour les patterns de récurrence
export const RecurrencePatternSkeleton: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div className={`recurrence-pattern-skeleton ${className}`}>
    <Skeleton variant="text" width="85%" />
  </div>
);

export const EventCardSkeleton: React.FC<EventCardSkeletonProps> = ({
  className = ''
}) => {
  return (
    <div className={`event-card event-card--with-image event-card--skeleton ${className}`}>
      {/* Background skeleton (simule l'image de fond) */}
      <div className="event-card__background event-card__skeleton-bg" />

      {/* Header : tags + actions */}
      <div className="event-card__header">
        <div className="event-card__tags">
          <Skeleton variant="tag" />
          <Skeleton variant="tag" />
        </div>
        <div className="event-card__actions">
          <Skeleton variant="icon" />
          <Skeleton variant="icon" />
        </div>
      </div>

      {/* GlassPanel skeleton en bas */}
      <div className="event-card__glass-container">
        <div className="event-card__skeleton-glass">
          <div className="event-card__glass-content">
            {/* Titre */}
            <Skeleton variant="title" width="70%" />

            {/* Date row : icône + texte */}
            <div className="event-card__glass-row">
              <div className="event-card__glass-icon">
                <Skeleton variant="rectangle" width="32px" height="36px" />
              </div>
              <div className="event-card__glass-info">
                <Skeleton variant="text" width="45%" />
                <Skeleton variant="text" width="60%" />
              </div>
            </div>

            {/* Location row */}
            <div className="event-card__glass-row">
              <div className="event-card__glass-icon">
                <Skeleton variant="icon" width="20px" height="20px" />
              </div>
              <div className="event-card__glass-info">
                <Skeleton variant="text" width="55%" />
              </div>
            </div>

            {/* Price row */}
            <div className="event-card__glass-row">
              <div className="event-card__glass-icon">
                <Skeleton variant="icon" width="20px" height="20px" />
              </div>
              <div className="event-card__glass-info">
                <Skeleton variant="text" width="30%" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Template pour PreviewCardMap
export const PreviewCardSkeleton: React.FC<{ className?: string }> = ({ className = '' }) => (
  <div className={`preview-card-map__card preview-card-map__card--skeleton ${className}`}>
    <div className="preview-card-map__tags">
      <Skeleton variant="tag" />
      <Skeleton variant="tag" />
      <Skeleton variant="tag" />
    </div>

    <div className="preview-card-map__main-content">
      <div className="preview-card-map__image">
        <Skeleton variant="image" height="80px" />
      </div>

      <div className="preview-card-map__content">
        <div className="preview-card-map__header">
          <Skeleton variant="title" width="75%" />
          <Skeleton variant="subtitle" width="50%" />
        </div>

        <div className="preview-card-map__footer">
          <Skeleton variant="button" width="100px" />
          <div className="preview-card-map__actions">
            <Skeleton variant="icon" />
            <Skeleton variant="icon" />
          </div>
        </div>
      </div>
    </div>
  </div>
); 